import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconFavorite, IconFavoriteBorder } from '@travel-frontend/icons';
import { forwardRef } from 'react';
import { Container } from '../../primitives/Favorite/components/Container.js';
import { Counter } from '../../primitives/Favorite/components/Counter.js';
import { Label } from '../../primitives/Favorite/components/Label.js';
const FavoriteComponent = forwardRef(({
  count = 0,
  label,
  filled,
  variant = 'primary',
  ...restProps
}, ref) => {
  return _jsxs(Container, {
    variant: variant,
    ref: ref,
    ...restProps,
    children: [filled ? _jsx(IconFavorite, {}) : _jsx(IconFavoriteBorder, {}), !!count && _jsx(Counter, {
      compact: count > 9,
      children: count
    }), !!label && _jsx(Label, {
      children: label
    })]
  });
});
FavoriteComponent.displayName = 'Favorite';
export const Favorite = /*#__PURE__*/_styled(FavoriteComponent, process.env.NODE_ENV === "production" ? {
  target: "e12yzi4w0"
} : {
  target: "e12yzi4w0",
  label: "Favorite"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZhdm9yaXRlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVdrRCIsImZpbGUiOiJGYXZvcml0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBJY29uRmF2b3JpdGUsIEljb25GYXZvcml0ZUJvcmRlciB9IGZyb20gJ0B0cmF2ZWwtZnJvbnRlbmQvaWNvbnMnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvRmF2b3JpdGUvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgQ291bnRlciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvRmF2b3JpdGUvY29tcG9uZW50cy9Db3VudGVyLmpzJztcbmltcG9ydCB7IExhYmVsIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9GYXZvcml0ZS9jb21wb25lbnRzL0xhYmVsLmpzJztcbmNvbnN0IEZhdm9yaXRlQ29tcG9uZW50ID0gZm9yd2FyZFJlZigoeyBjb3VudCA9IDAsIGxhYmVsLCBmaWxsZWQsIHZhcmlhbnQgPSAncHJpbWFyeScsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IHtcbiAgICByZXR1cm4gKF9qc3hzKENvbnRhaW5lciwgeyB2YXJpYW50OiB2YXJpYW50LCByZWY6IHJlZiwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogW2ZpbGxlZCA/IF9qc3goSWNvbkZhdm9yaXRlLCB7fSkgOiBfanN4KEljb25GYXZvcml0ZUJvcmRlciwge30pLCAhIWNvdW50ICYmIF9qc3goQ291bnRlciwgeyBjb21wYWN0OiBjb3VudCA+IDksIGNoaWxkcmVuOiBjb3VudCB9KSwgISFsYWJlbCAmJiBfanN4KExhYmVsLCB7IGNoaWxkcmVuOiBsYWJlbCB9KV0gfSkpO1xufSk7XG5GYXZvcml0ZUNvbXBvbmVudC5kaXNwbGF5TmFtZSA9ICdGYXZvcml0ZSc7XG5leHBvcnQgY29uc3QgRmF2b3JpdGUgPSBzdHlsZWQoRmF2b3JpdGVDb21wb25lbnQpIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RmF2b3JpdGUuanMubWFwIl19 */");